import { getMeta } from './helpers';

// Set webpack public asset url
window.__webpack_public_path__ = getMeta('theme-url');

import { Application } from '@hotwired/stimulus';
import AxiosFormController from './controllers/axios-form-controller';
import ExpandableController from './controllers/expandable-controller';
import ModalController from './controllers/modal-controller';
import SliderController from './controllers/slider-controller';
import FileUploadController from './controllers/file-upload-controller';
import ReadMoreController from "./controllers/read-more-controller";

require('./navigation');

const application = Application.start();

application.register('axios-form', AxiosFormController);
application.register('modal', ModalController);
application.register('slider', SliderController);
application.register('expandable', ExpandableController);
application.register('file-upload', FileUploadController);
application.register('read-more', ReadMoreController);
